import { Component, forwardRef, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { Produktionsstatus, VirkesorderStatus } from "~app/common/models/constants";
import { ArbetsorderSearchFilterComponent } from "../../components/arbetsorder-search-filter/arbetsorder-search-filter.component";
import { ArbetsorderSearchBasePanel } from "../../models/arbetsorder-search-base-panel";

@Component({
    selector: "rask-arbetsorder-search-status",
    templateUrl: "./arbetsorder-search-status.component.html",
    styleUrls: ["./arbetsorder-search-status.component.scss"],
    providers: [
        { provide: ArbetsorderSearchBasePanel,
            useExisting: forwardRef(() => ArbetsorderSearchStatusComponent) }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ArbetsorderSearchFilterComponent,
        CheckboxComponent,
        FormsModule
    ]
})
export class ArbetsorderSearchStatusComponent extends ArbetsorderSearchBasePanel {
    produktionsstatus = Produktionsstatus;
    virkesorderstatus = VirkesorderStatus;

    constructor() {
        super();
    }

    isDirty(): boolean {
        return (this.searchFilter.status.planeringsstatus?.underPlanering) ||
               (this.searchFilter.status.planeringsstatus?.fardigplanerad) ||
               (this.searchFilter.status.planeringsstatus?.tillganglig) ||
               (this.searchFilter.status.produktionsstatus?.produktionsstatus?.length > 0) ||
               (this.searchFilter.status.voBehoverUppdateras) ||
               (this.searchFilter.status.virkesorderstatus?.length > 0);
    }

    forceUpdateFilterChange(): void {
        // Abstrakt metod som krävs, men som inte gör något i just denna komponent
    }

    updateProduktionsplaneringstatusar() {
        this.searchFilter.status.produktionsstatus.maskinlag.splice(0, this.searchFilter.status.produktionsstatus.maskinlag.length);
        this.searchFilter.status.produktionsstatus.produkter.splice(0, this.searchFilter.status.produktionsstatus.produkter.length);
        this.searchFilter.status.produktionsstatus.drivningspunkter.splice(0, this.searchFilter.status.produktionsstatus.drivningspunkter.length);
        this.searchFilter.status.produktionsstatus.destinerad.splice(0, this.searchFilter.status.produktionsstatus.destinerad.length);
    }

    hasProduktionsstatusValue(status: string) {
        return (this.searchFilter.status.produktionsstatus.produktionsstatus.includes(status));
    }

    toggleProduktionsstatusValue(status: string, checked: boolean) {
        const produktionsstatus = this.searchFilter.status.produktionsstatus.produktionsstatus;
        if (checked && !this.hasProduktionsstatusValue(status)) {
            produktionsstatus.push(status);
        }
        if (!checked && this.hasProduktionsstatusValue(status)) {
            produktionsstatus.splice(produktionsstatus.indexOf(status), 1);
        }
    }

    hasVirkesorderstatusValue(status: string) {
        return (this.searchFilter.status.virkesorderstatus?.includes(status));
    }

    toggleVirkesorderstatusValue(status: any, checked: boolean) {
        const virkesorderstatus = this.searchFilter.status.virkesorderstatus;
        if (checked && !this.hasVirkesorderstatusValue(status)) {
            virkesorderstatus.push(status);
        }
        if (!checked && this.hasVirkesorderstatusValue(status)) {
            virkesorderstatus.splice(virkesorderstatus.indexOf(status), 1);
        }
    }

    hasCheckedValue(value: any) {
        // eslint-disable-next-line sonarjs/prefer-single-boolean-return
        if (!value) {
            return false;
        }
        return true;
    }

}
